import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { Spin, message } from 'antd'
import BookingDetailPage from '../components/BookingDetail'
import api from '../utils/api'

const BookingDetailPageWrapper = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [booking, setBooking] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchBooking = async () => {
      // 優先從location.state獲取預約數據
      if (location.state?.booking) {
        setBooking(location.state.booking)
        return
      }

      // 如果沒有傳遞數據，但有 id 參數，則從 API 獲取
      if (id) {
        try {
          setLoading(true)
          const response = await api.get(`/api/business/bookings/${id}`)
          if (response.data?.success && response.data?.data) {
            setBooking(response.data.data)
          } else {
            message.error('無法獲取預約詳情')
            navigate('/appointments')
          }
        } catch (error) {
          console.error('獲取預約詳情失敗:', error)
          message.error('無法獲取預約詳情')
          navigate('/appointments')
        } finally {
          setLoading(false)
        }
      } else {
        // 如果既沒有 state 也沒有 id，顯示錯誤並返回
        message.error('無法獲取預約詳情')
        navigate('/appointments')
      }
    }

    fetchBooking()
  }, [id, location.state, navigate])

  const handleClose = () => {
    navigate('/appointments')
  }

  const handleUpdate = (updatedBooking) => {
    setBooking(updatedBooking)
    message.success('預約已更新')
    // 可以選擇是否要更新location.state中的數據
    // 但通常不需要，因為用戶可能會返回列表頁面
  }

  const handleDelete = async (bookingId) => {
    try {
      await api.delete(`/api/business/bookings/${bookingId}`)
      message.success('預約已刪除')
      navigate('/appointments')
    } catch (error) {
      console.error('Error deleting booking:', error)
      message.error('刪除預約失敗')
    }
  }

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <Spin size='large' />
      </div>
    )
  }

  if (!booking) {
    return null
  }

  return (
    <BookingDetailPage
      booking={booking}
      onClose={handleClose}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      isMobile={false}
    />
  )
}

export default BookingDetailPageWrapper
